export default "__VITE_ASSET__1XSwZeqs__"